export var SEARCH_KEYS;
(function (SEARCH_KEYS) {
    SEARCH_KEYS["RECENT_SEARCH"] = "recentSearch";
    SEARCH_KEYS["RECENT_SEARCH_TERMS"] = "recentSearchTerms";
    SEARCH_KEYS["SEARCH_DATA"] = "searchData";
    SEARCH_KEYS["RECENT_SEARCH_DATA"] = "recentSearchData";
    SEARCH_KEYS["LATEST_SEARCH_WORD"] = "latestSearchWord";
})(SEARCH_KEYS || (SEARCH_KEYS = {}));
export var SEARCH_EVENTS;
(function (SEARCH_EVENTS) {
    SEARCH_EVENTS["GET"] = "get";
    SEARCH_EVENTS["DELETE"] = "delete";
    SEARCH_EVENTS["UPDATE"] = "update";
    SEARCH_EVENTS["REFRESH"] = "refresh";
})(SEARCH_EVENTS || (SEARCH_EVENTS = {}));
